import { render, staticRenderFns } from "./popso.vue?vue&type=template&id=15109c46"
import script from "./popso.vue?vue&type=script&lang=js"
export * from "./popso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports